import React, { useEffect, useState } from 'react';
import { Accordion, ProgressBar, Button } from 'react-bootstrap';
import OndemandVideoRoundedIcon from '@mui/icons-material/OndemandVideoRounded';
import { getCourseSyllabus } from "../../api/utils";

export default function SyllabusAccordion(props) {
  const [activeKey, setActiveKey] = useState(0);
  const {data} = props;
  const [loadingData, setLoadingData] = useState(true);
  const [syllabus, setSyllabus] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [syllabusData] = await Promise.all([
          getCourseSyllabus(data)
        ]);
  
        if (syllabusData.status) {
          setSyllabus(syllabusData.data);
          setLoadingData(false);
        }
      } catch (error) {
        console.log("Error fetching data:", error);
      }
    };
  
    if (data) {
      fetchData();
    }
  }, [data]);

  return (
    <div className='mt-8'>
      {loadingData ? (
        <div className="text-center my-5">
          <span className="spinner-border text-primary" role="status" />
          <p className="mt-3">Loading syllabus...</p>
        </div>
      ) : syllabus?.chapters?.length > 0 ? (
        <>
          <span className='text-center'><h1 className='text-grey'><strong>Syllabus</strong></h1></span>
          <span className='text-center'><p className="text-muted text-warning">{syllabus['topics']} Topics • {syllabus['lecture_count']} Lectures</p></span>
          <Accordion activeKey={activeKey} className='rounded-4'>
            {syllabus.chapters.map((module, index) => {
              const isDisabled = index !== 0;
  
              return (
                <Accordion.Item
                  eventKey={index.toString()}
                  key={module.id}
                  className={`mb-3 shadow-sm ${isDisabled ? 'disabled-accordion' : ''}`}
                >
                  <Accordion.Header
                    onClick={(e) => {
                      if (!isDisabled) {
                        setActiveKey(index.toString());
                      } else {
                        e.preventDefault();
                      }
                    }}
                    style={isDisabled ? { pointerEvents: 'none', opacity: 0.5 } : {}}
                  >
                    <div className="d-flex flex-column">
                      <strong>{module.title}</strong>
                      <small className="text-muted">
                        {module.lectures} Lectures • {module.duration}
                      </small>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    {module.lessons.map((lesson, idx) =>
                      lesson.isQuiz ? (
                        <div className="d-flex justify-content-between align-items-center text-warning" key={idx}>
                          <span className='h6 mx-3 txt-underlined'>{lesson.title}</span>
                          <span className="text-muted txt-small">
                            {lesson.questions} Questions | {lesson.points} Points
                          </span>
                        </div>
                      ) : (
                        <div className="d-flex justify-content-between align-items-center" key={idx}>
                          <span className='h6 text-muted mx-3'>
                            <OndemandVideoRoundedIcon className='mr-1' /> {lesson.title}
                          </span>
                          <div>
                            {lesson.preview && (
                              <Button size="sm" variant="none" className="active-tab m-3">
                                Preview
                              </Button>
                            )}
                            <small className="text-muted">{lesson.time}</small>
                          </div>
                        </div>
                      )
                    )}
                  </Accordion.Body>
                </Accordion.Item>
              );
            })}
          </Accordion>
        </>
      ) : (
        <p className="text-muted text-center my-5">No syllabus available for this course.</p>
      )}
    </div>
  );
  
}
